import { render, staticRenderFns } from "./Templateupdate.vue?vue&type=template&id=75da0cbb&"
import script from "./Templateupdate.vue?vue&type=script&lang=js&"
export * from "./Templateupdate.vue?vue&type=script&lang=js&"
import style0 from "./Templateupdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports